import {
  Skeleton,
  Stack,
  Typography
} from '@mui/material';
import { theme } from 'theme';



export type StyledCompanyMetricFieldProps = {
  label: string;
  value: string;
  isLoading?: boolean;
};

export const FC = (props: StyledCompanyMetricFieldProps) => {
  return (
    <Stack
      direction='row'
      justifyContent='space-between'
    >
      <Typography
        variant='tabSectionTextRegular'
      >
        {props.label}
      </Typography>
      {props.isLoading
        ? (
          <Skeleton sx={{
            minWidth: 100
          }}
          />
        )
        : (
          <Typography
            variant='tabSectionTextRegular'
            color={theme.palette.gray.light60}
          >
            {props.value}
          </Typography>
        )}
    </Stack>
  );
};
